if (!String.prototype.matchAll) {
    const matchAll = require('string.prototype.matchall');
    matchAll.shim();
}